@if (isReport && reportData?.data !== null) {
<div class="mc">

  <!-- ── Body: photo + data ── -->
  <div class="mc__body">

    <!-- Photo column -->
    <div class="mc__photo-col" *ngxPermissionsOnly="'USER_ID_IMAGE_READ'">
      <div class="mc__photo-wrap">
        <img class="mc__photo"
             [src]="'data:image/jpg;base64,' + clientReportData?.Picture"
             alt="clientImage" />
        <div class="mc__photo-badge"
             (mouseenter)="mouseEnter()"
             (mouseleave)="mouseLeave()">
          <itfg-id-card-face-verification
            [civilId]="reportData?.civilId"
            [loadedMiReportId]="reportData?.id"
            [loadedIdCardDocumentId]="selectedIdCardFront?.id">
          </itfg-id-card-face-verification>
        </div>
      </div>
    </div>

    <!-- Data columns -->
    <div class="mc__data">

      <!-- ── Section: Document ── -->
      <!-- ── Section: Document ── -->
      <div class="mc__section">
        <div>
          <span class="mc__section-label">{{ 'identityReports.idCardVerified' | translate }}</span>
          <span class="mc__doc-status"
                [class.mc__doc-status--valid]="clientReportData?.DocumentActualStatus === IDCardVerifiedType.VALID"
                [class.mc__doc-status--invalid]="clientReportData?.DocumentActualStatus !== IDCardVerifiedType.VALID">
            {{ clientReportData?.DocumentActualStatus }}
            @if (clientReportData?.DocumentStatusReason) {
              <span class="mc__doc-reason">— {{ clientReportData?.DocumentStatusReason }}</span>
            }
          </span>
        </div>
        @if (!isClientDataMatch) {
          <mat-icon class="mc__mismatch-icon" matTooltip="{{ 'identityReports.clientDataDoNotMatch' | translate }}">
            person_outline
          </mat-icon>
        }
      </div>

      <!-- ── Section: Names ── -->
      <div class="mc__grid">
        <div class="mc__field">
          <span class="mc__label">{{ 'identityReports.lastName' | translate }}</span>
          <span class="mc__value" [matTooltip]="clientReportData?.PersonNames?.FamilyName">
            {{ clientReportData?.PersonNames?.FamilyName || '—' }}
          </span>
        </div>
        <div class="mc__field">
          <span class="mc__label">{{ 'identityReports.firstName' | translate }}</span>
          <span class="mc__value" [matTooltip]="clientReportData?.PersonNames?.FirstName">
            {{ clientReportData?.PersonNames?.FirstName || '—' }}
          </span>
        </div>
        <div class="mc__field">
          <span class="mc__label">{{ 'identityReports.middleName' | translate }}</span>
          <span class="mc__value" [matTooltip]="clientReportData?.PersonNames?.Surname">
            {{ clientReportData?.PersonNames?.Surname || '—' }}
          </span>
        </div>
      </div>

      <!-- ── Section: Civil ── -->
      <div class="mc__grid">
        <div class="mc__field">
          <span class="mc__label">{{ 'global.civilId' | translate }}</span>
          <span class="mc__value mc__value--mono">{{ civilId || '—' }}</span>
        </div>
        <div class="mc__field">
          <span class="mc__label">{{ 'global.genderAndAge' | translate }}</span>
          <span class="mc__value">
            {{ 'global.' + civilIdGender + 'Short' | translate }}
            / {{ civilIdAge }} {{ 'global.ageShort' | translate }}
          </span>
        </div>
        <div class="mc__field">
          <span class="mc__label">{{ 'global.citizenship' | translate }}</span>
          <span class="mc__value"
                [class.mc__value--warn]="clientReportData?.NationalityList?.length > 1"
                [matTooltip]="clientReportData?.NationalityList | displayNationalityList">
            {{ clientReportData?.NationalityList | displayNationalityList }}
          </span>
        </div>
      </div>

      <!-- ── Section: Birth + Physical ── -->
      <div class="mc__grid">
        <div class="mc__field">
          <span class="mc__label">{{ 'global.dateOfBirth' | translate }}</span>
          <span class="mc__value mc__value--mono">
            {{ (clientReportData?.BirthDate | date) || (clientReportData?.DataForeignCitizen?.BirthDate | date) || '—' }}
          </span>
        </div>
        <div class="mc__field">
          <span class="mc__label">{{ 'mi.BirthPlace' | translate }}</span>
          <span class="mc__value" [matTooltip]="clientReportData?.BirthPlace?.TerritorialUnitName">
            {{ clientReportData?.BirthPlace?.TerritorialUnitName || clientReportData?.BirthPlace?.CountryName || '—' }}
          </span>
        </div>
        <div class="mc__field">
          <span class="mc__label">{{ 'identityReports.height' | translate }}</span>
          <span class="mc__value">
            {{ clientReportData?.Height ? clientReportData.Height + ('global.cmShort' | translate) : '—' }}
          </span>
        </div>
      </div>


      <!-- ── Section: Document details ── -->
      <div class="mc__grid">
        <div class="mc__field">
          <span class="mc__label">{{ 'identityReports.idCardNumber' | translate }}</span>
          <span class="mc__value mc__value--mono">{{ clientReportData?.IdentityDocumentNumber || '—' }}</span>
        </div>
        <div class="mc__field">
          <span class="mc__label">{{ 'identityReports.idCardIssuedDate' | translate }}</span>
          <span class="mc__value mc__value--mono">{{ (clientReportData?.IssueDate | date) || '—' }}</span>
        </div>
        <div class="mc__field">
          <span class="mc__label">{{ 'identityReports.idCardValidityDate' | translate }}</span>
          <span class="mc__value mc__value--mono">{{ (clientReportData?.ValidDate | date) || '—' }}</span>
        </div>
      </div>

      <!-- ── Section: Issuer + Physical ── -->
      <div class="mc__grid">
        <div class="mc__field">
          <span class="mc__label">{{ 'identityReports.idCardIssuer.name' | translate }}</span>
          <span class="mc__value">{{ clientReportData?.IssuerName || '—' }}</span>
        </div>
        <div class="mc__field">
          <span class="mc__label">{{ 'identityReports.height' | translate }}</span>
          <span class="mc__value">
            {{ clientReportData?.Height ? clientReportData.Height + ('global.cmShort' | translate) : '—' }}
          </span>
        </div>
        <div class="mc__field">
          <span class="mc__label">{{ 'identityReports.eyes.eyeColor' | translate }}</span>
          <span class="mc__value">{{ clientReportData?.EyesColor || '—' }}</span>
        </div>
      </div>

      <!-- ── Section: Address ── -->
      <div class="mc__grid">
        <div class="mc__field">
          <span class="mc__label">{{ 'identityReports.idCardAddress.city.name' | translate }}</span>
          <span class="mc__value" [matTooltip]="clientReportData?.PermanentAddress?.SettlementName">
            {{ clientReportData?.PermanentAddress?.SettlementName || '—' }}
          </span>
        </div>
        <div class="mc__field mc__field--span2">
          <span class="mc__label">{{ 'identityReports.idCardAddress.address' | translate }}</span>
          <span class="mc__value" [matTooltip]="clientReportData?.address">
            {{ clientReportData?.address || '—' }}
          </span>
        </div>
      </div>


      <!-- ── Section: Foreign citizen (conditional) ── -->
      @if (dataForeignCitizen?.PN) {
        <div class="mc__grid">
          <div class="mc__field">
            <span class="mc__label">{{ 'mi.PIN' | translate }}</span>
            <span class="mc__value mc__value--mono" [matTooltip]="dataForeignCitizen?.PIN">
              {{ dataForeignCitizen?.PIN || '—' }}
            </span>
          </div>
          <div class="mc__field">
            <span class="mc__label">{{ 'mi.PN' | translate }}</span>
            <span class="mc__value mc__value--mono" [matTooltip]="dataForeignCitizen?.PN">
              {{ dataForeignCitizen?.PN || '—' }}
            </span>
          </div>
          <div class="mc__field">
            <span class="mc__label">{{ 'mi.RPTypeofPermit' | translate }}</span>
            <span class="mc__value" [matTooltip]="clientReportData?.RPTypeofPermit">
              {{ clientReportData?.RPTypeofPermit || '—' }}
            </span>
          </div>
        </div>
      }

    </div>
  </div>

</div>
}